import type { GraphComponent, ILabel, INode, Rect } from '@ardoq/yfiles';
import { JSONLabel } from '@ardoq/api-types';

/**
 * Abstract token class for node export support via lookup pattern.
 * Use this with node.lookup(NodeExportSupport) to get export capabilities from node styles.
 */
export abstract class NodeExportSupport {
  abstract getSubShapeLayout(gc: GraphComponent, node: INode): Rect | null;
}

/** Abstract token class for label export support via lookup pattern.
 * Use this with node.lookup(LabelExportSupport) to get export capabilities from node styles.
 */
export abstract class LabelExportSupport {
  abstract toJSON(gc: GraphComponent, node: ILabel): JSONLabel | JSONLabel[];
}
